import { Component, Input } from '@angular/core';

@Component({
  selector: 'orgbrain-empty-page',
  templateUrl: './empty-page.component.html',
  styleUrls: ['./empty-page.component.scss'],
    standalone: false
})
export class EmptyPageComponent {
  @Input() text: string = 'Nothing here... Change this text';
  @Input() subtext: string;
  @Input() image: string = '/assets/svg-icons/empty.svg';
}
